var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckWithBackground = function SvgCheckWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E5F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.79 22.242a.9.9 0 0 0-1.273 0L26.91 39.849l-7.424-7.425a.9.9 0 1 0-1.273 1.273l8.06 8.061a.9.9 0 0 0 1.274 0L45.79 23.515a.9.9 0 0 0 0-1.273Z",
    fill: "url(#check-with-background_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check-with-background_svg__a",
    x1: 17.949,
    y1: 21.978,
    x2: 36.9,
    y2: 48.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A93E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504CCB"
  })))));
};
export default SvgCheckWithBackground;